module.exports = __webpack_public_path__ + "img/main_img2.2bd8419c.jpg";